'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DownloadPage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('ui/blocks');

var _layout = require('hellosign/common/layout');

var _logo = require('common/components/logo');

var _logo2 = _interopRequireDefault(_logo);

require('./download-page.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = _react2['default'].Component,
    PropTypes = _react2['default'].PropTypes;


var iconSrc = require('./folder_clip.svg');

/**
 * This is a full-page component for a file download screen with an automatic download.
 */

var DownloadPage = exports.DownloadPage = function (_Component) {
    _inherits(DownloadPage, _Component);

    function DownloadPage(props) {
        _classCallCheck(this, DownloadPage);

        var _this = _possibleConstructorReturn(this, (DownloadPage.__proto__ || Object.getPrototypeOf(DownloadPage)).call(this, props));

        _this.handleDownloadLinkClick = _this.handleDownloadLinkClick.bind(_this);
        return _this;
    }

    _createClass(DownloadPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                downloadUrl = _props.downloadUrl,
                onDownload = _props.onDownload;

            if (downloadUrl.startsWith('https://')) {
                window.location = downloadUrl;
            } else {
                console.log('Skipping download redirect because URL is missing or invalid');
            }

            if (typeof onDownload == 'function') {
                onDownload({ automatic: true });
            }
        }
    }, {
        key: 'handleDownloadLinkClick',
        value: function handleDownloadLinkClick(event) {
            var onDownload = this.props.onDownload;

            if (typeof onDownload == 'function') {
                onDownload({ automatic: false });
                event.preventDefault(); // Prevent actual navigation
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                heading = _props2.heading,
                downloadUrl = _props2.downloadUrl,
                backLabel = _props2.backLabel,
                backUrl = _props2.backUrl;

            return _react2['default'].createElement(
                _layout.Layout,
                { responsive: true },
                _react2['default'].createElement(
                    _blocks.Box,
                    { pb: 5, pt: 5 },
                    _react2['default'].createElement(_logo2['default'], { siteCode: 'S', isLink: true, href: '/' })
                ),
                _react2['default'].createElement(
                    _layout.Main,
                    { style: { textAlign: 'center' } },
                    _react2['default'].createElement(
                        _blocks.Box,
                        { m: 2 },
                        _react2['default'].createElement('img', {
                            alt: 'File icon',
                            src: iconSrc,
                            style: { height: '100px' }
                        })
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        {
                            mb: 4,
                            style: { fontSize: '26px', fontWeight: 'bold' }
                        },
                        heading
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        null,
                        'Your download should begin shortly. If not,',
                        ' ',
                        _react2['default'].createElement(
                            'a',
                            {
                                href: downloadUrl,
                                onClick: this.handleDownloadLinkClick
                            },
                            _react2['default'].createElement(
                                'strong',
                                null,
                                'click here'
                            )
                        ),
                        '.'
                    ),
                    _react2['default'].createElement(
                        _blocks.Box,
                        { mt: 5, mb: 5 },
                        _react2['default'].createElement(
                            'a',
                            { href: backUrl },
                            'Go back to ',
                            backLabel
                        )
                    )
                )
            );
        }
    }]);

    return DownloadPage;
}(Component);

DownloadPage.propTypes = {
    heading: PropTypes.string.isRequired,
    downloadUrl: PropTypes.string.isRequired,
    backLabel: PropTypes.string.isRequired,
    backUrl: PropTypes.string.isRequired,
    onDownload: PropTypes.func // Used for tests/storybook
};

exports['default'] = DownloadPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/download-page/download-page.jsx
 ** module id = 1192
 ** module chunks = 0
 **/